import { useTranslation } from "react-i18next"
import UserImage from "../commons/UserImage"
import { NavLink } from "react-router-dom"
import EntityFingerprint from "components/commons/EntityFingerprint"


function UserCardLayout({
    user,
    employment
}) {

    const [t, i18n] = useTranslation(["global"])

    return (
        <div className="col mb-5">
            <div className="card bg-dark h-100">
                <div className="card-header bg-black bg-opacity-10">
                    <div className="row">
                        <div className="col-auto">
                            <UserImage guid={user.guid} size={96} />
                        </div>

                        <div className="col-auto">
                            <h5 className="card-title">{user.displayName}</h5>

                           

                            <span className="badge " style={{ backgroundColor: employment.role.backgroundColor, color: employment.role.textColor, padding: "10px" }}>{employment.role.name}</span>
                            {
                                employment.businessUnit &&
                                <NavLink to={"/dashboard/businessUnits/detail"} state={employment.businessUnit}><span className="badge bg-black bg-opacity-10 text-white p-2 mx-2"><i className="fas fa-building"></i> {employment.businessUnit.name}</span></NavLink>
                            }

                        </div>
                        <div className="col-auto"> {
                                !user.enabled &&
                                <span ><i style={{color:"red"}} className="fa-solid fa-circle-exclamation"></i> User not enabled</span>
                            }</div>

                    </div>
                </div>
                <div className="card-body">

                    <div className="row">
                        <div className="col">
                            <p>
                                <span className="text-accent"><i className="fa-solid fa-envelope"></i> {t("property.email")} <br /> </span>
                                {
                                    user.email ?
                                        // <a href={`mailto:${user.email}`} className="text-white ">{user.email}</a>
                                        <>{user.email}</>
                                        : <>no email </>
                                }
                            </p>
                        </div>


                        <div className="col">
                            <p>
                                <span className="text-accent"><i className="fa-solid fa-user-lock"></i> Username <br /> </span>
                                {user.username}
                            </p>
                        </div>
                        <div className="col">
                            <h6 className="text-accent"><i className="fa-solid fa-briefcase"></i> {t("menu.employment_info")}</h6>
                            <p className="fs-6">{t("helper.employed_on_as", { date: new Date(employment.startDateTimeMillis).toLocaleDateString(), roleDesc: employment.role.description })}</p>
                        </div>
                    </div>
                </div>

                <div className="card-footer">
                    <EntityFingerprint guid={user.guid}/>
                </div>

            </div>
        </div>
    )




}

export default UserCardLayout